import { render } from "./FinalMessage.vue?vue&type=template&id=1891eefc&scoped=true"
import script from "./FinalMessage.vue?vue&type=script&lang=js"
export * from "./FinalMessage.vue?vue&type=script&lang=js"

import "./FinalMessage.vue?vue&type=style&index=0&id=1891eefc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1891eefc"]])

export default __exports__